import {Injectable} from '@angular/core';
import {PagedFilterDTO, PagedFilterDTONew} from '../models/PagedFilterDTO';
import {Common} from '../util/Util';
import {PagedRequestDTO} from '../models/PagedRequestDTO';

@Injectable({
  providedIn: 'root'
})
export class FilterDataService {

  getFieldMapHashMap(filterField: string, filterValue: string, fieldMapHashMap: any): any {
    const fieldMap = {};
    const pagedFilterDTO = new PagedFilterDTO();

    pagedFilterDTO.name = filterField;
    pagedFilterDTO.value = filterValue;
    fieldMap[filterField] = pagedFilterDTO;

    fieldMapHashMap = {
      ...fieldMapHashMap,
      ...fieldMap
    };

    Object
    .keys(fieldMapHashMap)
    .forEach(key => {
      if (fieldMapHashMap[key].value === Common.EMPTY_VALUE) {
        delete fieldMapHashMap[key];
      }
    });

    return fieldMapHashMap;
  }

  addFieldMapValues(pagedRequestDTO: PagedRequestDTO, fieldMapItems: string[], filterValue: string): PagedRequestDTO {
    for (let i = 0; i < fieldMapItems.length; i++) {
        const pagedFilterDTO = new PagedFilterDTONew();
        pagedFilterDTO.name = fieldMapItems[i];
        pagedFilterDTO.value = filterValue.trim();
        pagedRequestDTO.fieldMap[fieldMapItems[i]] = pagedFilterDTO;
  
        if (i !== 0) {
          pagedFilterDTO.logicGate = 'OR';
        }
      }
  
      return pagedRequestDTO;
  }

  filterSelectedItemsBasedOnFieldMap<T>(selectedItems: T[], fieldMapHashMap: any): T[] {
    let itemsMatchingFilter = [...selectedItems];

    Object
      .keys(fieldMapHashMap)
      .forEach(key => {
        itemsMatchingFilter = itemsMatchingFilter.filter(
          (item) => item[key]?.toLowerCase().includes(fieldMapHashMap[key].value?.toLowerCase())
        );
      });

    return itemsMatchingFilter;
  }
}
